import React from 'react';

const NairaIcon = () => <span>&#8358;</span>;

export default NairaIcon;
